<template>

  <div>
    <div v-if="value && value < 1000">
      {{value}} Mbps
    </div>
    <div v-else-if="value && value >= 1000">
      {{value/1000}} Gbps
    </div>
    <div v-else>
      N/A
    </div>
  </div>

</template>

<script>
export default {
  name: 'SpeedTableCell',
  props: ['value'],
};
</script>
